import * as yup from 'yup';

const loginSchema = yup.object().shape({
  email: yup.string().email('login.errors.email').required('common.required'),
  password: yup.string().required('common.required'),
});

export default loginSchema;
